(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/grassroot-result.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/grassroot-result.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.GrassrootResult = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.result(data);
    },
    templateContext: function() {
      if (svs.utils.ns.isNamespace('svs.grassroots.data.result', window)) {
        return {
          cmsSource: true
        };
      }
      return {
        resultDetails: {
          regions: this.collection.toJSON()
        },
        cmsSource: false
      };
    },
    className: 'js-grassroots-search-wrapper bg-white grassroots-pop-up',
    events: {
      'click .js-navigate-back': 'navigate'
    },
    initialize: function() {
      var self = this;
      $(document).on('expandable-box-resize', function() {
        var openedBox = $('.expandable-box-open');
        var tagToFind;
        var tag;
        var receiverSearch = $('#receiverSearch');
        var cmsSource = svs.utils.ns.isNamespace(
          'svs.grassroots.data.result',
          window
        );
        var region;
        var regionImage;
        var $topContent = $('#top-content');
        var headerHeight = $topContent.height() + $topContent.offset().top;

        if (cmsSource) {
          if (svs.core.detect.formfactor.mobile()) {
            tagToFind = '.js-region-result';
          } else {
            tagToFind = '.content-image-wrapper';
          }
        } else {
          tagToFind = 'img';
        }
        tag = openedBox.find(tagToFind);
        if (openedBox.length > 0) {
          if (self.getRegion('receiverSearch')) {
            self.removeRegion('receiverSearch');
            receiverSearch.remove();
          }
          if (tag.length > 0) {
            if (cmsSource && svs.core.detect.formfactor.mobile()) {
              region = tag.data('region');
              regionImage = self.collection.findWhere({ name: region });
              tag.append(svs.content.image.templates.image(regionImage.get('image')));
            } else if (!cmsSource) {
              !svs.utils.ns.isNamespace('svs.grassroots.data.result', window) &&
                tag.attr('src', tag.data('src'));
            }
          } else {
            tag = openedBox.find('a');
          }
          tag.after('<div id="receiverSearch"></div>');
          self.addRegion('receiverSearch', '#receiverSearch');
          self
            .getRegion('receiverSearch')
            .show(new svs.grassroots.views.SearchReceivers());
          $('html,body').animate(
            { scrollTop: openedBox.offset().top - headerHeight },
            150
          );
        }
      });
    },
    onAttach: function() {
      var $body = $('body');
      var nav = $('.nav');
      var navAndHeaderHeight;
      if (
        (svs.core.detect.breakpoint.current === 'lg' ||
          svs.core.detect.breakpoint.current === 'xl') &&
        $body.hasClass('nav-top')
      ) {
        navAndHeaderHeight = $('#top-content').height() + nav.height();
      } else {
        navAndHeaderHeight = $('#top-content').height();
      }
      $('.js-grassroots-search-wrapper').css(
        'min-height',
        $body.height() - (navAndHeaderHeight + 24)
      );
      $body.scrollTop(0);
      $body.scrollLeft(0);
    },
    navigate: function(e) {
      if (e.currentTarget && e.currentTarget.getAttribute('data-url')) {
        var url = e.currentTarget
          .getAttribute('data-url')
          .substring(e.currentTarget.getAttribute('data-url').lastIndexOf('/'));
        svs.grassroots.router.navigate(url, {
          trigger: true,
          silent: false,
          replace: false
        });
        return false;
      }
      return true;
    }
  });
})(Backbone, _, svs);


 })(window);